import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

let base = `company-applications`
AdminRouter.addRoutes([
  {
    name: `company-application`,
    path: `/company-application`,
    component: () => import('./ApplicationForm.vue'),
    meta: {
      auth: false,
    },
  },
  {
    name: base,
    path: `/company-applications`,
    component: () => import('./Index.vue'),
    meta: {
      auth: true,
    },
  },
  {
    name: `${base}.edit`,
    path: `/${base}/:id`,
    component: () => import('./Edit.vue'),
    meta: {
      auth: true,
    },
  },
])

AdminSidebar.pushItem({
  id: base,
  order: 20,
  header: $vm => $vm.$t(`general.menu_management`),
  text($vm) {
    return $vm.$t('companies.applications')
  },
  route: {
    name: base,
  },
  icon: 'icon-files-empty',
  permission: 'administer',
})

messageGroups.push('companies')
messageGroups.push('company')
messageGroups.push('attributes')
